export enum CustomDialogTypeEnum {
  Confirm = 'confirm',
  Warning = 'warning',
}
